<div class="row">

  <legend>
    <h3>Recuperación de contraseña</h3>
  </legend>

  <div class="paragraph">
    <p>
      En esta sección se puede realizar el restablecimiento de la clave para ingresar a la Ventanilla Única
      Digital de Trámites y Servicios en Línea. Por favor registre su usuario y el correo electrónico que
      registro al momento de realizar el proceso de registro en el sistema.
    </p>
  </div>

  <div class="col-sm-12 col-md-9">
    <div class="entradas-de-texto-govco">
      <label for="Usuario">Usuario<span class="required">(*)</span></label>
      <input type="text" id="usuario" placeholder="Usuario" />
    </div>
  </div>

  <div class="col-sm-12 col-md-9">
    <div class="entradas-de-texto-govco">
      <label for="correo-electronico">Correo Electrónico<span class="required">(*)</span></label>
      <input type="text" id="correo-electronico" placeholder="Correo Electrónico" />
    </div>
  </div>

  <div class="col-12 col-md-12 pl-4 text-center">
    <div class="col-12" >
      <br><br>
      <button type="button" class="btn-govco fill-btn-govco">Enviar</button>
      <br><br>
      <button type="button" class="btn-govco fill-btn-govco">Regresar</button>
    </div>
  </div>

</div>


